import styled from "styled-components";

export const Container = styled("div") <{ gutter?: number }>`
  ${(props) => {
    const { gutter, margin } = props.theme.grid;

    let styles = `
      width: 100%;
      padding-right: ${props.gutter / 2 || gutter / 2}px;
      padding-left: ${props.gutter / 2 || gutter / 2}px;
      margin-right: auto;
      margin-left: auto;
      
      @media ( max-width: 767px ) {
        padding-right: ${gutter / 2}px;
        padding-left: ${gutter / 2}px;
      }
      `;

    return styles;
  }}
`;
